import type { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'

import { useMay, type Requirement } from '@/features/auth/access'

/**
 * Route guard for a screen the user may not be allowed to open.
 *
 * Sends them to the dashboard rather than to an explanation. There is nothing useful to
 * say: they did not click a link to get here -- every link that leads here is hidden from
 * them -- so this is a typed URL, a stale bookmark, or a back button after a role change,
 * and a page whose only content is "no" is worse than the page they can use.
 *
 * `replace` so the back button does not bounce them straight back into the redirect.
 */
export function RequirePermission({
  requirement,
  children,
}: {
  requirement?: Requirement
  children: ReactElement
}): ReactElement {
  return useMay(requirement) ? children : <Navigate to="/" replace />
}
